import React, { FC } from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import Button from 'src/components/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';

export interface ModalProps {
  width?: number | string;
  loading?: boolean;
  hideActionButtons?: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
  showModal: boolean;
  hideCloseIcon?: boolean;
  toggleModal: () => void;
  onConfirm?: () => void;
  children: any;
}

const ModalWrapper: FC<ModalProps> = (props) => {
  const {
    width = 900,
    showModal,
    toggleModal,
    onConfirm = () => { },
    children,
    loading = false,
    hideActionButtons,
    hideCloseIcon,
    cancelButtonText = 'Cancel',
    confirmButtonText = 'Confirm',
  } = props;

  const { breakpoints } = useTheme();
  const matches = useMediaQuery(breakpoints.down('md'));

  const style = {
    width: matches ? '95%' : width,
    maxHeight: '95%',
    overflow: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    borderRadius: '5px',
  };

  return (
    <Modal open={showModal} onClose={toggleModal}>
      <Box sx={style}>
        <Box position="relative">
          {children}

          {!hideActionButtons && (
            <Box>
              <Button onClick={toggleModal} data-qa-submit>
                {cancelButtonText}
              </Button>
              <Button
                loading={loading}
                onClick={onConfirm}
                data-qa-submit
                style={{ margin: '0 15px' }}
              >
                {confirmButtonText}
              </Button>
            </Box>
          )}

          {!hideCloseIcon && (
            <Box
              onClick={toggleModal}
              sx={{
                top: '15px',
                right: '10px',
                cursor: 'pointer',
                position: 'absolute',
                padding: '4px',
                background: 'transparent',
              }}
            >
              <CloseRounded style={{ fill: 'var(--main-primary-color)' }} />
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalWrapper;
